module.exports = __webpack_public_path__ + "static/media/frown.a5b19a1d.svg";